// Simulated network delay standing in for the future Sheets API / Apps
// Script calls, so the loading overlay has something to show against right
// now. Replace call sites with real awaited fetches once those are wired up.
export function simulateNetworkDelay(ms = 500) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
